import {API, NEW_API} from "../HttpHandler";
import config from "../../../config";

export const getQueueStatusFromStore = (selectedStoreUuid, urlTotemId) => {
  let params = null;
  const queueStatusUrl = config.endPoints.queueStatus;
  const storeIdPlaceholder = /storeIdPlaceholder/gi;
  const url = queueStatusUrl.replace(storeIdPlaceholder, selectedStoreUuid);
  params = {
    priority: 0,
  };
  if (urlTotemId?.length > 0) {
    params = {
      ...params,
      totemId: urlTotemId,
    };
  }

  return NEW_API.get(url, {params});
};

export const bookQueue = (selectedQueueDetails) => {
  return NEW_API.post(config.endPoints.bookQueue, selectedQueueDetails);
};
